/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Container } from 'react-bootstrap';
import Github from '../../components/Github/Github';

import { Col, Row } from 'react-bootstrap';
import {
  DiCss3,
  DiHtml5,
  DiJavascript1,
  DiLaravel,
  DiMysql,
  DiPhp,
  DiReact,
  DiWordpress,
} from 'react-icons/di';
import {
  SiDocker,
  SiFigma,
  SiGit,
  SiLinux,
  SiRedux,
  SiTailwindcss,
  SiTypescript,
  SiVisualstudiocode,
  SiWindows,
} from 'react-icons/si';

function TechStack() {
  return (
    <Container fluid className="about-section">
      <Container>
        <h1 className="project-heading">
          <strong className="purple">Professional Skillset</strong>
        </h1>
        <br />
        <br />
        <h3 className="purple">Programming Language</h3>

        <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <DiJavascript1 />
            JavaScript
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <SiTypescript />
            TypeScript
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <DiPhp />
            PHP
          </Col>
        </Row>

        <h3 className="purple">Markup Language</h3>
        <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <DiHtml5 />
            HTML
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <DiCss3 />
            CSS
          </Col>
        </Row>
        <h3 className="purple">Framework/Library</h3>
        <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <DiReact />
            React
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <SiRedux />
            Redux
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <DiLaravel />
            Laravel
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <DiWordpress />
            Wordpress
          </Col>
        </Row>
        <h3 className="purple">Database</h3>
        <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <DiMysql />
            MySQL
          </Col>
        </Row>
        <h3 className="purple">Tools</h3>
        <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <SiVisualstudiocode />
            VSCode
          </Col>

          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <SiGit />
            <br />
            Git
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <SiDocker />
            Docker
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <SiTailwindcss />
            Tailwindcss
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <SiFigma />
            Figma
          </Col>
        </Row>
        <h3 className="purple">Operating System</h3>
        <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <SiWindows />
            Windows
          </Col>

          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            <SiLinux />
            Linux
          </Col>
        </Row>
        <h3 className="purple">Communication Language</h3>
        <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            English
          </Col>

          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            Japanese
          </Col>
          <Col xs={4} sm={3} md={2} lg={1} className="tech-icons">
            Bengali
          </Col>
        </Row>

        <Github />
      </Container>
    </Container>
  );
}

export default TechStack;
